// src/api/cargoTypeService.js
// (don't change the file name if it's already in use)

import api from "./api"; // shared Axios instance

// IMPORTANT: baseURL already contains ".../api",
// so here we show only the controller segment
const BASE = "/CargoType";

// Get all cargo types
export const getCargoTypes = async () =>
    (await api.get(BASE)).data;

// Get a single cargo type by id
export const getCargoType = async (id) =>
    (await api.get(`${BASE}/${id}`)).data;

// Create a cargo type
export const createCargoType = async (data) =>
    (await api.post(BASE, data)).data;

// Update a cargo type
export const updateCargoType = async (id, data) =>
    (await api.put(`${BASE}/${id}`, data)).data;

// Delete a cargo type
export const deleteCargoType = async (id) =>
    (await api.delete(`${BASE}/${id}`)).data;

export default {
    getCargoTypes,
    getCargoType,
    createCargoType,
    updateCargoType,
    deleteCargoType,
};
